import {
    Orientation,
    RemoteMode,
    PlayerPlayMode,
} from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { Dependencies } from '@/scenarios/legacy-player/hooks/analytics/use-dependencies';

import { readPlayerArgs } from '../readers/read-player-args';

const defaultPlayerMeta = {
    orientation: Orientation.Horizontal,
    remoteMode: RemoteMode.Disabled,
    playMode: PlayerPlayMode.Online,
};

interface Params {
    uiParams: {
        contentId: string;
        psid: string;
        manifestUrl: string;
    };
    dependencies: Dependencies;
    callbackParams: [{ vsid: string; isDynamicPrerollEnabled: boolean }];
}

export function playerContent({ dependencies, uiParams, callbackParams }: Params) {
    const [{ vsid }] = callbackParams;
    const { contentId } = uiParams;
    const evgenParams = readPlayerArgs(dependencies, { contentId });

    return { vsid, ...defaultPlayerMeta, ...uiParams, ...evgenParams };
}
